import { query } from "./strapi";

export interface LegalArticle {
  id: number;
  title: string;
  url: string;
  description: string;
  fullContent: string;
  category: string;
  date: string | null;
  duration: string | null;
  image?: {
    url: string;
  };
  seo?: {
    title?: string;
    description?: string;
    image?: string;
    keywords?: string;
    structuredData?: any;
    openGraph?: any;
    noIndex?: boolean;
    canonicalUrl?: string;
  };
}

// Map Strapi category to internal tab names
export const categoryToTabMap: Record<string, string> = {
  "terminos-y-condiciones": "terms",
  "politicas-de-privacidad": "privacy",
  "politica-de-envios": "shipping",
  "politica-cambios-devoluciones": "returns",
  "promociones-y-descuentos": "promotions",
};

// Map internal tab names to Strapi categories
export const tabToCategoryMap: Record<string, string> = {
  terms: "terminos-y-condiciones",
  privacy: "politicas-de-privacidad",
  shipping: "politica-de-envios",
  returns: "politica-cambios-devoluciones",
  promotions: "promociones-y-descuentos",
};

// Get a specific legal article by URL
export function getLegalArticleByUrl(articleUrl: string) {
  console.log(`Fetching legal article with URL: ${articleUrl}`);
  return query(`legal/by-url/${articleUrl}`)
    .then((res) => {
      console.log(`Raw API response for article ${articleUrl}:`, res);

      if (!res) {
        console.error(
          "getLegalArticleByUrl: API returned null/undefined for URL:",
          articleUrl
        );
        throw new Error("Legal article not found");
      }

      // Extract article data from nested structure if needed
      let articleData;

      if (res.data) {
        console.log("Article data is nested in .data property");
        articleData = res.data;
      } else {
        console.log("Article data is at root level");
        articleData = res;
      }

      // Validate that we have the expected data
      if (!articleData.title) {
        console.error("Article data missing title:", articleData);
        throw new Error("Invalid article data structure: missing title");
      }

      console.log("Successfully processed article data:", {
        id: articleData.id,
        title: articleData.title,
        category: articleData.category,
        url: articleData.url,
      });

      return articleData;
    })
    .catch((err) => {
      console.error("Error fetching legal article:", err);
      throw err;
    });
}

// Get all legal articles by category
export function getLegalArticlesByCategory(category: string) {
  return query(`legal/by-category/${encodeURIComponent(category)}`)
    .then((res) => {
      if (!res) {
        return [];
      }

      // Extract articles from nested structure if needed
      const articles = res.data ? res.data : res;

      // If articles is an array, return it, otherwise return empty array
      return Array.isArray(articles) ? articles : [];
    })
    .catch((err) => {
      console.error("Error fetching legal articles by category:", err);
      return [];
    });
}

// Get all legal articles
export function getAllLegalArticles() {
  return query("legal")
    .then((res) => {
      if (!res) {
        return [];
      }

      // Extract articles from nested structure if needed
      const articles = res.data ? res.data : res;

      // If articles is an array, return it, otherwise return empty array
      return Array.isArray(articles) ? articles : [];
    })
    .catch((err) => {
      console.error("Error fetching all legal articles:", err);
      return [];
    });
}
